// @ts-nocheck
import { useState, useEffect } from 'react';
import jwt_decode from 'jwt-decode';
import { useCookies } from 'react-cookie';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

// 役員・事業本部一覧（WPからカテゴリIDを解決して取得する）
import { loadBoardVoice, loadDepartmentBlog, loadDepartmentBlogTwo } from '../../../files/blogCategories';

function NewPostInHeader() {
  const baseUrl = process.env.REACT_APP_PUBLIC_URL || '';
  const [cookies] = useCookies(["sessionToken"]);
  const [cookieJti, setCookieJti] = useState();
  const [cookieEmail, setCookieEmail] = useState();
  const [loading, setLoading] = useState(true);
  const [posts, setPosts] = useState([]);
  const [postFlg, setPostFlg] = useState(true);

  const urlBaseBigWig = process.env.REACT_APP_WP_REST_API_PATH_BIGWIG;
  const urlBaseDepartmentBlog = process.env.REACT_APP_WP_REST_API_PATH_DEPARTMENTBLOG;

  useEffect(() => {
    if (!cookieJti) SettingLoginData();
  }, []);

  function SettingLoginData() {
    const token = cookies.sessionToken;
    const decodedToken = jwt_decode(token);
    setCookieJti(decodedToken.jti);
    setCookieEmail(decodedToken.data.EMAIL);
  }

  useEffect(() => {
    if (cookieJti) getPosts();
  }, [cookieJti]);

  async function getPosts() {
    const now = new Date();
    now.setDate(now.getDate() - 7);
    const postAfter = '&after=' + now.toISOString().split('.')[0];

    // 新着記事がどの役員・事業本部のものかを判定するため、カテゴリIDを解決した一覧を取得する
    const [BoardVoice, DepartmentBlogJson, DepartmentBlogJsonTwo] = await Promise.all([
      loadBoardVoice(cookieJti),
      loadDepartmentBlog(cookieJti),
      loadDepartmentBlogTwo(cookieJti),
    ]);

    const urls = [
      {
        url: `${urlBaseBigWig}wp-json/wp/v2/posts?_fields=title,date,media_department,id${postAfter}&zenken=${cookieJti}`,
        // 準備中の役員（カテゴリ未作成）は記事がないため判定対象から外す
        jsonData: BoardVoice.filter((data) => !data.preparing),
        blogUrlBase: '/board-voice?id=',
        jsonKey: 'catId',
      },
      {
        url: `${urlBaseDepartmentBlog}wp-json/wp/v2/posts?_fields=title,date,media_department,id,parent_info${postAfter}&zenken=${cookieJti}`,
        jsonData: DepartmentBlogJson,
        blogUrlBase: '/deptBlog?id=',
        jsonKey: 'parent',
      },
      {
        url: `${urlBaseDepartmentBlog}wp-json/wp/v2/divisionBlogtwo?_fields=title,date,media_department,id,parent_info${postAfter}&zenken=${cookieJti}`,
        jsonData: DepartmentBlogJsonTwo,
        blogUrlBase: '/deptBlogTwo?id=',
        jsonKey: 'parent',
      }
    ];
    
    const postList = [];
    
    const fetchPromises = urls.map(item =>
      fetch(item.url)
        .then(res => res.json())
        .then(data => {
          if (!Array.isArray(data)) {
            return;
          }
    
          data.forEach(post => {
            const termId = post.parent_info?.term_id ?? post.media_department?.id;
            const matched = item.jsonData.find(j => j[item.jsonKey] == termId);
    
            if (!matched) {
              return;
            }
    
            post.blogTitle =
              item.blogUrlBase === '/board-voice?id='
                ? 'ブログ「' + (matched.title ?? '') + '」'
                : '';
    
            post.blogUrl = item.blogUrlBase + post.id + '&default=' + post.media_department?.id;
            post.date = post.date.split('T')[0].replace(/-/g, '/');
    
            postList.push(post);
          });
        })
    );

    await Promise.all(fetchPromises);

    postList.sort((a, b) => (a.date < b.date ? 1 : -1));
    setPosts(postList);
    setPostFlg(postList.length > 0);
    setLoading(false);
  }

  useEffect(() => {
    const bv_title = document.getElementsByClassName("bv_title");
    if (bv_title.length === 0) return;

    let i = 0;
    const timerId = setInterval(() => {
      // ページ遷移などで要素がなくなっていたら何もしない（bv_title は常に最新の要素を指すため0件になりうる）
      if (bv_title.length === 0) return;
      i = (i + 1) % bv_title.length;
      for (let j = 0; j < bv_title.length; j++) {
        bv_title[j].classList.remove("active");
      }
      bv_title[i].classList.add("active");
    }, 7500);

    // アンマウント時・posts更新時に前のタイマーを止める（止めないとページ遷移後も動き続ける）
    return () => clearInterval(timerId);
  }, [posts]);

  return (
    <>
      {loading ? null : (
        postFlg && posts.map((data, index) => (
          <a
            key={data.id}
            href={baseUrl + data.blogUrl}
            className={"bv_title" + (index === 0 ? " active" : "")}
            dangerouslySetInnerHTML={{
              __html:
                (data.title.rendered + "（" + data.media_department?.name + (data.blogTitle ? data.blogTitle + "）" : "）")).length > 40
                  ? (data.title.rendered + "（" + data.media_department?.name + (data.blogTitle ? data.blogTitle + "）" : "）")).substr(0, 40) + "…"
                  : data.title.rendered + "（" + data.media_department?.name + (data.blogTitle ? data.blogTitle + "）" : "）")
            }}
          ></a>
        ))
      )}
    </>
  );
}

export default NewPostInHeader;